import { c as _c } from "react/compiler-runtime";
import { type ComponentProps } from 'react';
export const LinkIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M8.1 11.7H4.5C3.015 11.7 1.8 10.485 1.8 9C1.8 7.515 3.015 6.3 4.5 6.3H8.1V4.5H4.5C2.016 4.5 0 6.516 0 9C0 11.484 2.016 13.5 4.5 13.5H8.1V11.7ZM13.5 4.5H9.9V6.3H13.5C14.985 6.3 16.2 7.515 16.2 9C16.2 10.485 14.985 11.7 13.5 11.7H9.9V13.5H13.5C15.984 13.5 18 11.484 18 9C18 6.516 15.984 4.5 13.5 4.5ZM12.6 8.1H5.4V9.9H12.6V8.1Z" fill="currentColor" style={{
      fill: "currentColor"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};